/**
 * How the Virtual Firewall detail moves the page to a part of itself (CTX-1265): the
 * header's pill goes up to the map, Show rules and a rule's name go down to the
 * table. Smooth, unless the user asked for reduced motion.
 */
export function scrollBehavior(): ScrollBehavior {
    const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    return reduce ? "auto" : "smooth";
}

export function scrollToElement(element: Element | null | undefined) {
    // jsdom lays nothing out and has no scrollIntoView; a browser always does.
    element?.scrollIntoView?.({ behavior: scrollBehavior(), block: "start" });
}

export const scrollToId = (id: string) => scrollToElement(document.getElementById(id));
